// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueFilter from 'vue-filter';
import VueAMap from 'vue-amap';
import { lazyAMapApiLoaderInstance } from 'vue-amap';
import TWEEN from '@tweenjs/tween.js';

import Moment from 'moment';
// A modern alternative to CSS resets
import 'normalize.css/normalize.css';

// element2.0
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import VueQuillEditor, { Quill } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import Video from './utils/formatQuillVideo.js';
import Image from './utils/formatQuillImg.js';

import App from './App.vue';
import Components from './components';
import Mixins from './mixins';
import Filter from './filters';
import store from './store';
import router from './router';
import http from './api/http';
import httpAuth from './api/http/httpAuth';

// 全局样式
import './styles/index.scss';
// 图标
import './icons';

http.router = router;
http.store = store;

httpAuth.router = router;
httpAuth.store = store;

Vue.use(Mixins);
Vue.use(VueFilter);
Vue.use(Filter);
Vue.use(Components);
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '5651105ce4cc16bd4debbdfdeb82eebe',
  plugin: ['Autocomplete', 'PlaceSearch', 'AMap.MouseTool', 'OverView', 'MapType', 'PolyEditor', 'AMap.CircleEditor', 'Geolocation', 'AMap.Rectangle', 'Scale', 'OverView', 'ToolBar', 'MapType', 'Marker'],
  v: '1.4.4',
  uiVersion: '1.0.11', // 版本号
});

Quill.register({ 'formats/image': Image, 'formats/video': Video }, true);

Vue.prototype.$moment = Moment;
Vue.prototype.$TWEEN = TWEEN;
Vue.TWEEN = TWEEN;

Vue.use(ElementUI, { size: 'small' });
Vue.use(VueQuillEditor);

Vue.config.productionTip = false;

/* eslint-disable no-new */

lazyAMapApiLoaderInstance
  .load()
  .then(() => {
    new Vue(App);
  })
  .catch((e) => {
    ElementUI.Message.error(e.message);
  });
// new Vue(App);
